<!-- Toolbar -->
<div class="toolbar" role="banner">
  <span class = "title">Odu Komban</span>
  <div class="spacer-long"></div>
  <a id="github-logo" aria-label="Github project repo" target="_blank" rel="noopener"
    href="https://github.com/Stormers-one/website-o_k" title="Github">
    <img src="assets/icons/github.svg" height="30" width="30">
  </a>
  <div class="spacer-short"></div>
  <button *ngIf="signedIn" class="signoutButton" (click)="signOut()">sign out</button>
</div>

<app-main-banner></app-main-banner>

<div class="content" role="main">
  <!-- Resources -->
  <div class="resource-box-1">
    <router-outlet></router-outlet>
  </div>

</div>

<!-- Footer -->
<footer>
  <span>Copyright 2021 by Stormers</span>
</footer>


